"use client";

import Icon from "../library/Icon";
import type {ReactNode} from "react";
import type {ToolApprovalStatus} from "./toolApprovalStatus";

export type ApprovalVisualState = ToolApprovalStatus | "selected-approval" | "selected-rejection";

export function approvalVisualState(status: ToolApprovalStatus, queued?: boolean | null): ApprovalVisualState {
   if (queued === true) return "selected-approval";
   if (queued === false) return "selected-rejection";
   return status;
}

/** Keep local choices separate from the operation's execution status. */
export function approvalBannerLabel(status: ToolApprovalStatus, queued?: boolean | null, statusKey = `toolApproval.${status}`) {
   if (queued != null) return queued ? "toolApproval.selectedApproval" : "toolApproval.selectedRejection";
   return status === "required" ? "toolApproval.waiting" : statusKey;
}

/** Labels come from the operation: an accepted request must never be called a saved change. */
export function ApprovalStatusBanner({state, children}: {state?: ApprovalVisualState; children: ReactNode}) {
   const busy = state === "submitting" || state === "approved";
   const checked = state === "completed" || state === "selected-approval";
   const rejected = state === "denied" || state === "selected-rejection";
   return <div className="approval-banner" data-approval-state={state}>
      <output>
         {busy ? <span aria-hidden className="approval-spinner" />
            : checked || rejected ? <span aria-hidden className={state === "completed" ? "approval-check" : "approval-decision-icon"}>
               <Icon icon={checked ? "check" : "xmark"} className="h-3 w-3" />
            </span> : <span aria-hidden className="approval-status-dot" />}
         {children}
      </output>
   </div>;
}
